export default __webpack_public_path__ + "static/media/alexander-krivitskiy-8gGUMSQQz0E-unsplash@2x.4aee4c1b.png";